import React, { useEffect } from 'react';
import MultiStepVideoEditor from './MultiStepVideoEditor';

export default function SampleTextLinker() {
    
    const data = {
        step: 1,
        sceneData: {
            "scenes": [
                {
                    "id": 1,
                    "text": "This is a sample text",
                    "duration": 5,
                    "voice": "en-US-Wavenet-A"
                },
                {
                    "id": 2,
                    "text": "This is another sample text",
                    "duration": 5,
                    "voice": "en-US-Wavenet-B"
                }
            ]
        }
    };
    return <MultiStepVideoEditor initialData={data} />;
}